import * as mns from '../../mutation-types';

export default {
    state () {
        return {
            interiorDecorationAndEquipment: false,
            homeMovableProperty: false,
            responsibility: false,
            structuralElements: false,
            interiorDecoration: false,
            insuredOrOwner: false,
            thirdPerson: false,
        }
    },
    getters: {
        interiorDecorationAndEquipment(state){
            return state.interiorDecorationAndEquipment;
        },
        homeMovableProperty(state){
            return state.homeMovableProperty;
        },
        responsibility(state){
            return state.responsibility;
        },
        structuralElements(state){
            return state.structuralElements;
        },
        interiorDecoration(state){
            return state.interiorDecoration;
        },
        insuredOrOwner(state){
            return state.insuredOrOwner;
        },
        thirdPerson(state){
            return state.thirdPerson
        }
    },
    mutations: {
        [mns.SET_INTERIOR_DECORATION_AND_EQUIPMENT](state, value){
            state.interiorDecorationAndEquipment = value;
        },
        [mns.SET_HOME_MOVABLE_PROPERTY](state, value){
            state.homeMovableProperty = value;
        },
        [mns.SET_RESPONSIBILITY](state, value){
            state.responsibility = value;
        },
        [mns.SET_STRUCTURAL_ELEMENTS](state, value){
            state.structuralElements = value;
        },
        [mns.SET_INTERIOR_DECORATION](state, value){
            state.interiorDecoration = value
        },
        [mns.SET_INSURED_OR_OWNER](state, value){
            state.insuredOrOwner = value;
        },
        [mns.SET_THIRD_PERSON](state, value){
            state.thirdPerson = value;
        },
    }
} // export.